import React from 'react'
import Lightbox from 'lightbox-react'
import 'lightbox-react/style.css'

export const Gallery = props => {
    const { items, photoIndex,  } = props
    return <Lightbox
        mainSrc={items[photoIndex]}
        nextSrc={items.length > 1 ? items[(photoIndex + 1) % items.length] : null }
        prevSrc={items.length > 1 ? items[(photoIndex + items.length - 1) % items.length] : null}
        {...props}
        />
}

export default Gallery



// WEBPACK FOOTER //
// ./src/components/Gallery.js